import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Окружающий мир. 2 класс",
        subject: "Бережное отношение к природе ",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Бережное отношение к природе ",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Артюхова Ирина Сергеевна",
                grade: "старший научный сотрудник лаборатории начального общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    paragraphs: [
                        `<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>
<p style="padding-bottom: 2.4rem;">Кейс нацелен на раскрытие методических приёмов построения урока, позволяющих предупредить трудности формирования у младших школьников бережного отношения к природе. Помогает педагогам увидеть и понять, в чём заключаются данные трудности. </p>
                        <p style="padding-bottom: 2.4rem;">В кейсе наглядно представлена (на примере конкретного урока) совокупность методических приёмов. Предлагается рассмотреть урок на тему «Ландыш майский – травянистое растение леса. Красная книга России» (2 класс). </p>
                        <p style="padding-bottom: 2.4rem;">Эмоционально акцентированные методические приёмы (приёмы, нацеленные на пробуждение у школьников соответствующих изучаемому содержанию эмоций) реализуют мотивационную, целевую и содержательную стороны процесса обучения и приводят к достижению запланированного результата. </p>
                        <p>Обучающиеся получают знания о редких растениях леса (например, ландыша майского), узнают о причинах их исчезновения или занесения в разряд редких растений, получают представление о предназначении Красной книги России, формулируют и эмоционально воспринимают правила поведения в лесу, способствующие сохранению редких растений.</p>
</div>`
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "11",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p>Актуальность кейса обусловлена социальным заказом – вниманием государства к решению задачи экологического воспитания, к реализации требований обновлённого Федерального государственного стандарта начального общего образования.</p>
                    <p>Планируемые результаты Федеральной программы по Окружающему миру в области экологического воспитания: </p>
                    <ul style="padding: 1rem">
                    <li>осознание роли человека в природе и обществе;</li>
                    <li>принятие экологических норм поведения;</li>
                    <li>бережное отношение к природе;</li>
                    <li>неприятие действий, приносящих ей вред.</li>
</ul>
                    <p>Кейс направлен на предупреждение трудностей формирования у младших школьников бережного отношения к природе, на неприятие действий, приносящих ей вред.</p>
                    <p>Среди выявленных трудностей: </p>
                    <ul style="padding: 1rem">
                    <li>Сложность установления младшими школьниками связи между действиями людей и их последствиями для природы. Им трудно представить, что одноразовое действие (соберу букет, сорву цветок) может вылиться в масштабное уничтожение растений. «Я сорву один цветок – ничего не случится!». А если так сделают ещё тысячи людей? Об этом дети не задумываются. </li>
                    <li>Низкий уровень познавательного интереса учеников к проблемам сохранения природы. Далеки и плохо представимы для детей последствия неправильного поведения в природе.</li>
</ul>
                    <p>Для преодоления этих трудностей разберём, как можно построить урок, активно задействуя эмоции школьников. </p>
                    <p>В первую очередь, речь идёт об удивлении, которое может быть как положительным, так и отрицательным. Удивите детей, заинтересуйте, вызовите живые эмоции и личную сопричастность! Хорошо известно, если процесс обучения не затрагивает эмоции ученика, то знания остаются невостребованными.</p>
                    <p>Удивление лежит в основе познавательного интереса: у обучающихся просыпается любопытство и желание познать то, что его вызывает.</p>
                    <p>Дайте ученикам возможность и чувствовать, и действовать: испытывать эмоции, думать, отвечать, размышлять, конструировать, исследовать, самим делать выводы. </p>
                    <p>И, конечно, в процессе обучения нельзя забывать о наглядности.</p>
                    <p>Таким образом, можно сказать, что методические «ключики» эффективного урока – это: </p>
                    <p>
                  <ul style="padding: 1rem">
                    <li>удивление, интерес младших школьников;</li>
                    <li>наглядность;</li>
                    <li>активные действия.</li>
</ul>  
</p>
<p>Посмотрим, как учитель предупреждает указанные трудности на конкретном уроке.</p>


`
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                  {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                 {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                 {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Федеральный государственный образовательный стандарт начального общего образования (ФГОС НОО), утверждён Приказом Министерства просвещения Российской Федерации от 31 мая 2021 г. № 286",
                "Федеральная образовательная программа начального общего образования (ФОП НОО), утверждена Приказом Министерства просвещения России от 16.11.2022 N 992, зарегистрировано в Минюсте России 22.12.2022 N 71762",
                "Виноградова Н.Ф. Окружающий мир. 2 класс. В 2-х частях. ФГОС. – Москва: Просвещение, 2022 (УМК «Начальная школа XXI века»)",
                "Окружающий мир. Реализация требований ФГОС начального общего образования: методическое пособие для учителя // [Н. Ф. Виноградова, И. С. Артюхова] ; под ред. Н. Ф. Виноградовой. – М.: ФГБНУ «Институт стратегии развития образования», 2023",
                "Артюхова И. С. Формирование у младших школьников первоначальных основ экологической культуры: примеры методических разработок // Начальное образование. 2022. №. 5. С. 30-33. DOI: https://doi.org/10.12737/1998-0728-2022-10-5-30-33  ",
                "Артюхова И. С. Формирование у младших школьников навыков здорового и безопасного образа жизни // Начальное образование. 2023. №. 1. С. 13-18. DOI: https://doi.org/10.12737/1998-0728-2023-11-1-13-18",
            ],
            filesToDownload: [
                {
                    link: "./files/biology_material.pdf",
                    fileName: "Лабораторная работа"
                }
            ]
        }
    ],
};